import { Chart } from "@scuf/charts";
import { Card } from "@scuf/common";
import { useEffect, useState } from "react";
import { TostadorFetching } from "../../../class/fetchTostador";
import { plotBackground } from "../../../config/colors";
import { useDate } from "../../../hooks/useDate";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";

export default function ImpurezasETPTeorico() {
  const initialFetch = new TostadorFetching().setIdSeccion(2).setSecuencia(49);

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();

  const [masaAsETPTeorica, setMasaAsETPTeorica] = useState(defaultObject);
  const [masaSbETPTeorica, setMasaSbETPTeorica] = useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);
      populateMasaSb(data);
      populateMasaAs(data);
      setDateHook(data, "Masa de As a ETP Teórica");
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateMasaSb(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Masa de Sb a ETP Teórica"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setMasaSbETPTeorica({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateMasaAs(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Masa de As a ETP Teórica"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setMasaAsETPTeorica({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Impurezas a ETP Teórico"}
            subtitle={"Periodo " + fullDate()}
          >
            {/** -------------------------------- Masa de As a ETP Teórica --------------------------------------- */}
            <Chart.Line
              name="Masa de As a ETP Teórica"
              data={masaAsETPTeorica.value}
              yAxis={0}
            />

            {/** -------------------------------- Masa de Sb a ETP Teórica --------------------------------------- */}
            <Chart.Line
              name="Masa de Sb a ETP Teórica"
              data={masaSbETPTeorica.value}
              yAxis={1}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={masaAsETPTeorica.fecha} />

            <Chart.YAxis
              labelSuffix=" t/h"
              title="Masa de Arsenico"
              lineWidth={2}
              lineColor="white"
              min={0}
            />

            <Chart.YAxis
              labelSuffix=" t/h"
              title="Masa de Antimonío"
              lineWidth={2}
              lineColor="white"
              opposite={true}
              min={0}
            />

          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
